import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { HorizontalDiv, VerticalDiv } from '../../../../../components/Common';
import ListItem from '../../../../../components/ListItem';
import EditableInfoText from '../../CrAlerts/EditableInfoText';

ThreshingDate.propTypes = {
    className: PropTypes.string,
    techFormData: PropTypes.shape({
        threshing: PropTypes.string
    })
};

function ThreshingDate({ className, techFormData }) {
    // Format the threshing date as DD/MMM/YYYY (e.g., 15/Nov/2024)
    const threshingDateRaw = techFormData?.threshing;
    const threshingDate = threshingDateRaw && moment(threshingDateRaw).isValid()
        ? moment(threshingDateRaw).format('DD/MMM/YYYY')
        : '-';

    return (
        <div className={className}>
            <ListItem>
                {() => (
                    <VerticalDiv>
                        <ContainerDiv>
                            <VerticalDiv>
                                <h5>Threshing Date</h5>
                            </VerticalDiv>
                        </ContainerDiv>
                        <EditableInfoText
                            isEditable={false}
                            initialValue={threshingDate}
                            rows={3}
                        />
                    </VerticalDiv>
                )}
            </ListItem>
        </div>
    );
}

const ContainerDiv = styled(HorizontalDiv)`
    justify-content: space-between;
`;

export default ThreshingDate;

